import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramDetail } from '@/api/overseasSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuVisitorProgramView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const dataForm = reactive<FbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(dataForm, res.data)
  })
})

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

const visitorProgramFormRef = ref()
const handleVisitComplete = (row = dataForm) => {
  router.push({ path: '/ofbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleEdit = () => {
  router.push({ path: '/ofbu/visitorProgram/edit', query: { id: route.query.id as string } })
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_CosViewContent = _resolveComponent("CosViewContent")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_CosViewContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: activeTabs.value,
                "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeTabs).value = $event)),
                onChange: handleTabsChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "info",
                    tab: _unref(t)('common.baseTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(VisitorProgramForm, {
                        ref_key: "visitorProgramFormRef",
                        ref: visitorProgramFormRef,
                        title: _unref(t)('clue.visitorDetailTitile'),
                        value: dataForm,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
                        type: "view",
                        isEdit: false
                      }, null, 8, ["title", "value"])
                    ]),
                    _: 1
                  }, 8, ["tab"]),
                  _createVNode(_component_a_tab_pane, {
                    key: "logs",
                    tab: _unref(t)('common.operationLogTabs')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(TabsOperationLog, {
                        appId: "cos_ofbu",
                        tableId: "DcCosOFbuVisitorOperationLog",
                        resourceId: _unref(route).query.id as string
                      }, null, 8, ["resourceId"])
                    ]),
                    _: 1
                  }, 8, ["tab"])
                ]),
                _: 1
              }, 8, ["activeKey"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_cos_footer_button, { hideOk: true }, {
        default: _withCtx(() => [
          (dataForm.status !== 3)
            ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                key: 0,
                workCode: dataForm.dutyBy,
                controlType: "none",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                ]),
                _: 1
              }, 8, ["workCode"])), [
                [_directive_permission, 'ofbu_visitor_edit_btn']
              ])
            : _createCommentVNode("", true),
          (dataForm.status !== 3)
            ? _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                key: 1,
                workCode: dataForm.dutyBy,
                controlType: "none",
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleVisitComplete()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.completeVisit')), 1)
                ]),
                _: 1
              }, 8, ["workCode"])), [
                [_directive_permission, 'ofbu_visitor_complete_btn']
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})